export const SIDEBAR_TABS = [
  // 1. Tournament
  {
    key: "tournament_leaderboard",
    label: "Tournament Leaderboard",
    href: "/tournament-leaderboard",
    category: "Tournament",
    description: "Public & dashboard tournament leaderboards"
  },
  // 2. Management
  {
    key: "analytics_overview",
    label: "Analytics Overview",
    href: "/",
    category: "Management",
    description: "Main dashboard charts, revenue, and stats"
  },
  {
    key: "user_management",
    label: "User Management",
    href: "/user-management",
    category: "Management",
    description: "System users, profile images, and access permissions"
  },
  {
    key: "employee_management",
    label: "Employee Management",
    href: "/employee-management",
    category: "Management",
    description: "EPL active employees and positions roster"
  },
  {
    key: "payroll_sales_analytics",
    label: "Payroll: Sales Analytics",
    href: "/dashboard/payroll/sales-analytics",
    category: "Management",
    description: "Toast POS sales summaries and comparisons"
  },
  {
    key: "payroll_salary",
    label: "Payroll: Settings / Salary",
    href: "/dashboard/payroll/salary",
    category: "Management",
    description: "Employee hourly rates and salary configurations"
  },
  {
    key: "payroll_bonuses",
    label: "Payroll: Entry / Bonuses",
    href: "/dashboard/payroll/bonuses",
    category: "Management",
    description: "Bonus entries, deductions, and payroll calculation"
  },
  {
    key: "token_reserves",
    label: "Token Reserves",
    href: "/token-reserves",
    category: "Management",
    description: "Reserve token vaults and withdrawal tracking"
  },
  {
    key: "tables_time",
    label: "Starting/Closing Tables Time",
    href: "/starting-closing-tables-time",
    category: "Management",
    description: "Poker table opening and closing audit logs"
  },
  {
    key: "tax_management",
    label: "Tax Management",
    href: "/tax-management",
    category: "Management",
    description: "Dynamic tip share tax rates and audit change logs"
  },
  // 3. Transactions
  {
    key: "tips_dealer",
    label: "Tips: Dealer Tips",
    href: "/dealer-tips",
    category: "Transactions",
    description: "Dealer tokes and dynamic tax calculations"
  },
  {
    key: "tips_dealer_actions",
    label: "Tips: Dealer - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Dealer Tips table",
    href: ""
  },
  {
    key: "tips_waitress",
    label: "Tips: Server/waitress Tips",
    href: "/waitress-tips",
    category: "Transactions",
    description: "Server and waitress tip outs"
  },
  {
    key: "tips_waitress_actions",
    label: "Tips: Server/waitress - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Server/waitress Tips table",
    href: ""
  },
  {
    key: "tips_floor",
    label: "Tips: Floor Tips",
    href: "/floor-tips",
    category: "Transactions",
    description: "Floor Supervisor tip out records"
  },
  {
    key: "tips_floor_actions",
    label: "Tips: Floor - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Floor Tips table",
    href: ""
  },
  {
    key: "tips_bartender",
    label: "Tips: Bartender Tips",
    href: "/bartender-tips",
    category: "Transactions",
    description: "Bartender tip transactions & owe to Toast"
  },
  {
    key: "tips_bartender_actions",
    label: "Tips: Bartender - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Bartender Tips table",
    href: ""
  },
  {
    key: "tips_host",
    label: "Tips: Host Tips",
    href: "/host-tips",
    category: "Transactions",
    description: "Host & front desk tip records"
  },
  {
    key: "tips_host_actions",
    label: "Tips: Host - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Host Tips table",
    href: ""
  },
  {
    key: "tips_cashier",
    label: "Tips: Cashier Tips",
    href: "/cashier-tips",
    category: "Transactions",
    description: "Cashier cage tip outs"
  },
  {
    key: "tips_cashier_actions",
    label: "Tips: Cashier - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Cashier Tips table",
    href: ""
  },
  {
    key: "tips_janitor",
    label: "Tips: Custodian/Janitor Tips",
    href: "/janitor-tips",
    category: "Transactions",
    description: "Custodian & Janitor tip records"
  },
  {
    key: "tips_janitor_actions",
    label: "Tips: Custodian/Janitor - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Custodian/Janitor Tips table",
    href: ""
  },
  {
    key: "tips_cook",
    label: "Tips: Cook Tips",
    href: "/cook-tips",
    category: "Transactions",
    description: "Kitchen & Cook tip records"
  },
  {
    key: "tips_cook_actions",
    label: "Tips: Cook - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Cook Tips table",
    href: ""
  },
  {
    key: "tips_other",
    label: "Tips: Other Positions",
    href: "/other-tips",
    category: "Transactions",
    description: "Tip records for custom & additional employee roles"
  },
  {
    key: "tips_other_actions",
    label: "Tips: Other Positions - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Other Positions Tips table",
    href: ""
  },
  {
    key: "promos",
    label: "Promos",
    href: "/promos",
    category: "Transactions",
    description: "Promotional giveaways and receipt tracking"
  },
  {
    key: "promos_actions",
    label: "Promos - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Promos table",
    href: ""
  },
  {
    key: "petty_cash",
    label: "Petty Cash",
    href: "/petty-cash",
    category: "Transactions",
    description: "Club expenses and webcam receipt uploads"
  },
  {
    key: "petty_cash_actions",
    label: "Petty Cash - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit, Delete and Receipt Upload actions in Petty Cash table",
    href: ""
  },
  {
    key: "poker_cash_box",
    label: "Poker Cash Box",
    href: "/poker-cash-box",
    category: "Transactions",
    description: "Denomination chip counters and save logs"
  },
  {
    key: "tournament_poker_chips",
    label: "Tournament Poker Chips",
    href: "/tournament-poker-chips",
    category: "Transactions",
    description: "Tournament chip inventory records"
  },
  {
    key: "tournament_house_fees",
    label: "Tournament House Fees",
    href: "/tournament-house-fees",
    category: "Transactions",
    description: "House fee allocations and transactions"
  },
  {
    key: "tournament_house_fees_actions",
    label: "Tournament House Fees - Actions Column",
    category: "Transactions",
    isAction: true,
    description: "Unhide/show Edit and Delete actions in Tournament House Fees table",
    href: ""
  },
  {
    key: "transaction_actions",
    label: "All Transactions: Actions Master Switch",
    category: "Transactions",
    isAction: true,
    description: "Global fallback switch for Actions column across all transaction tables",
    href: ""
  },
  // 4. Table Tracker & SMS
  {
    key: "player_profiles",
    label: "Player Profiles",
    href: "/player-profiles",
    category: "Table Tracker",
    description: "EPL player accounts, tiers, and loyalty"
  },
  {
    key: "sms_logs",
    label: "SMS",
    href: "/sms-logs",
    category: "Table Tracker",
    description: "Twilio SMS dispatches and delivery reports"
  },
];

export const CATEGORIES = [
  "Tournament",
  "Management",
  "Transactions",
  "Table Tracker"
];

/**
 * Returns default canonical tab permissions for any role name.
 */
export const getDefaultPermissionsByRole = (roleName) => {
  const norm = String(roleName || "").trim().toLowerCase();
  const perms = {};
  SIDEBAR_TABS.forEach((tab) => {
    perms[tab.key] = false;
  });

  if (norm === "admin" || norm === "management") {
    SIDEBAR_TABS.forEach((tab) => {
      perms[tab.key] = true;
    });
  } else if (norm === "admin leaderboard") {
    perms["tournament_leaderboard"] = true;
  } else if (norm === "cashier" || norm === "floor supervisor" || norm === "floorsupervisor") {
    SIDEBAR_TABS.forEach((tab) => {
      if (
        tab.category === "Transactions" ||
        tab.category === "Table Tracker" ||
        tab.key === "tournament_leaderboard"
      ) {
        perms[tab.key] = true;
      }
    });
  } else if (norm === "dealer") {
    perms["tips_dealer"] = true;
    perms["tournament_leaderboard"] = true;
  } else if (norm === "server/waitress" || norm === "waitress" || norm === "server") {
    perms["tips_waitress"] = true;
    perms["tournament_leaderboard"] = true;
  } else if (norm === "bartender") {
    perms["tips_bartender"] = true;
    perms["tournament_leaderboard"] = true;
  } else if (norm === "host" || norm === "hosts") {
    perms["tips_host"] = true;
    perms["tournament_leaderboard"] = true;
  } else if (norm === "cook" || norm === "cooks") {
    perms["tips_cook"] = true;
    perms["tournament_leaderboard"] = true;
  } else if (norm === "custodian/janitor" || norm === "janitor" || norm === "custodian") {
    perms["tips_janitor"] = true;
    perms["tournament_leaderboard"] = true;
  } else {
    // Other custom roles (Runner, Busser, Chef, etc.) default to Other Tips and Leaderboard
    perms["tips_other"] = true;
    perms["tournament_leaderboard"] = true;
  }

  return perms;
};

/**
 * Maps a module or position name to its specific action permission key.
 */
export const getTransactionActionKey = (moduleOrPosition) => {
  const norm = String(moduleOrPosition || "").trim().toLowerCase();
  if (norm.includes("dealer")) return "tips_dealer_actions";
  if (norm.includes("waitress") || norm.includes("server")) return "tips_waitress_actions";
  if (norm.includes("floor")) return "tips_floor_actions";
  if (norm.includes("bartender")) return "tips_bartender_actions";
  if (norm.includes("host")) return "tips_host_actions";
  if (norm.includes("cashier")) return "tips_cashier_actions";
  if (norm.includes("janitor") || norm.includes("custodian")) return "tips_janitor_actions";
  if (norm.includes("cook")) return "tips_cook_actions";
  if (norm.includes("other")) return "tips_other_actions";
  if (norm.includes("promo")) return "promos_actions";
  if (norm.includes("petty")) return "petty_cash_actions";
  if (norm.includes("tournament") || norm.includes("house_fee") || norm.includes("house-fee")) {
    return "tournament_house_fees_actions";
  }
  return "transaction_actions";
};

/**
 * Checks whether the current user has permission to view/perform actions
 * (Actions column with Edit & Delete buttons) across transaction tables.
 * Controlled dynamically per transaction module in Manage Roles.
 *
 * @param {object} currentUser The current authenticated user object
 * @param {string} moduleOrPosition The module or tip position name (e.g., 'Dealer', 'Promos', 'petty_cash')
 */
export const canPerformTransactionActions = (currentUser, moduleOrPosition) => {
  if (!currentUser) return false;
  const normRole = String(currentUser?.role || "").trim().toLowerCase();
  if (currentUser?.isAdmin || normRole === "admin" || normRole === "management") {
    return true;
  }

  const actionKey = getTransactionActionKey(moduleOrPosition);

  // If dynamic permissions are populated on the user
  if (currentUser?.permissions && typeof currentUser.permissions === "object") {
    // 1. Check module-specific action permission
    if (typeof currentUser.permissions[actionKey] !== "undefined") {
      return Boolean(currentUser.permissions[actionKey]);
    }
    // 2. Check global master switch / fallback if module-specific key isn't explicitly set
    if (typeof currentUser.permissions.transaction_actions !== "undefined") {
      return Boolean(currentUser.permissions.transaction_actions);
    }
  }

  // 3. Fallback to role defaults: Cashier and Floor Supervisor have actions by default, others do not
  return ["cashier", "floor supervisor", "floorsupervisor", "floor"].includes(normRole);
};

/**
 * Checks if a pathname is allowed based on dynamic permissions object.
 * If user is Admin or permissions is null/undefined, allows all.
 */
export const isPathAllowedByPermissions = (pathname, permissions, role) => {
  if (!pathname) return true;
  const normRole = String(role || "").trim().toLowerCase();
  if (normRole === "admin" || normRole === "management") return true;

  // Use dynamic permissions if populated; otherwise fallback to safe role defaults
  const effectivePerms =
    permissions && typeof permissions === "object" && Object.keys(permissions).length > 0
      ? permissions
      : getDefaultPermissionsByRole(role);

  // Find matching tab (only tabs that correspond to navigations / routes)
  const matchingTab = SIDEBAR_TABS.find((tab) => {
    if (!tab.href) return false;
    if (tab.href === "/" && pathname === "/") return true;
    if (tab.href !== "/" && (pathname === tab.href || pathname.startsWith(`${tab.href}/`))) {
      return true;
    }
    return false;
  });

  if (!matchingTab) return true; // Unregistered route (allow by default)

  return effectivePerms[matchingTab.key] === true;
};
